export default {
  styleOverrides: {
    item: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
};
